import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_mguckchsha: FaireCollectionEntity = {
  token: "pbc_mguckchsha",
  type: "collection",
  name: "garden flowers",
  heroImageUrl:
    "https://cdn.faire.com/fastly/dfefea8ca131279b5036776103ee273120c8763e1be971a078c6d63253e57f2b.jpeg",
  itemCount: 18,
  brandToken: "b_mmdanrh9jf",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:09:23.410Z",
    importedBy: "entity-db-import-collections",
  },
};
